export enum TransferDirection {
    NONE = 0,
    OUT = 1,
    IN = 2
}